module.exports = __webpack_public_path__ + "static/media/handball.596f6f0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/handball.svg
// module id = 381
// module chunks = 7